export const getMagazineArticleUrl = slug => {
  return `/magazine/${slug}`;
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/routes/util.js